import { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { Form, Button } from "react-bootstrap";

const OrderPaymentForm = (props) => {
    const rollbackOrder = props.rollbackOrder;

    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmitOrder = async () => {
        const res = await props.handleSubmitOrder();
        if(!res.error) {
            if (!stripe || !elements) {
                // Stripe.js has not yet loaded.
                // Make sure to disable form submission until Stripe.js has loaded.
                return;
            }

            setIsLoading(true);
            let returnUrl = 'http';
            if (process.env.NODE_ENV !== 'development') {
                returnUrl += 's';
            }
            returnUrl += 'https://app.anvil.earth/customer-dashboard';
            const { error } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    // Make sure to change this to your payment completion page
                    return_url: returnUrl,
                },
            });

            // This point will only be reached if there is an immediate error when
            // confirming the payment. Otherwise, your customer will be redirected to
            // your `return_url`. For some payment methods like iDEAL, your customer will
            // be redirected to an intermediate site first to authorize the payment, then
            // redirected to the `return_url`.
            if (error.type === "card_error" || error.type === "validation_error") {
                rollbackOrder(res);
                setMessage(error.message);
            } else {
                rollbackOrder(res);
                setMessage("An unexpected error occurred.");
            }

            setIsLoading(false);
        } else {
            rollbackOrder(res);
        }
    };

    const paymentElementOptions = {
        layout: "tabs"
    }
    return (
        <Form>
            <PaymentElement id="payment-element" options={paymentElementOptions} />
            <Button
                onClick={() => handleSubmitOrder()}
                disabled={isLoading || !stripe || !elements}
            >
                <span id="button-text">
                    {isLoading ? <div className="spinner" id="spinner"></div> : "Save"}
                </span>
            </Button>
            {/* Show any error or success messages */}
            {message && <div id="payment-message">{message}</div>}
        </Form>
    );
}
 
export default OrderPaymentForm;